// Builds the styled-components theme object from the server-side
// `branding` prop returned by OauthBranding.for (Ruby). Consumed by
// OAuthFlow/OAuthApp.jsx and SsoClaimFlow/SsoClaimApp.jsx so both SSO
// surfaces theme consistently.
//
// Any branding-less render (plain DEFAULT) produces the same dark palette
// the flows shipped with before this was introduced.
export default function buildThemeFromBranding(branding) {
  const b = branding || {};
  return {
    bg:             b.bgColor        || '#0D1117',
    pageBg:         b.pageBgCss      || b.bgColor || '#0D1117',
    surface:        b.surfaceColor   || 'var(--tz-wash, rgba(255, 255, 255, 0.03))',
    surface2:       b.surface2Color  || 'var(--tz-hairline, rgba(255, 255, 255, 0.05))',
    border:         b.borderColor    || 'var(--tz-hairline, rgba(255, 255, 255, 0.06))',
    borderFocus:    b.focusBorderColor || 'rgba(16, 171, 255, 0.5)',
    ring:           b.focusRingColor   || 'rgba(16, 171, 255, 0.1)',
    text:           b.textColor      || '#FFFFFF',
    textSecondary:  b.mutedColor     || '#9EA6B7',
    textTertiary:   b.muted2Color    || '#657185',
    accent:         b.accentColor    || '#10ABFF',
    accentText:     b.accentTextColor || '#FFFFFF',
    accentDim:      b.accentDimColor || 'rgba(16, 171, 255, 0.12)',
    error:          '#F67171',
    inputBg:        b.surface2Color  || 'var(--tz-hairline, rgba(255, 255, 255, 0.05))',
    inputBorder:    b.inputBorderColor || 'var(--tz-hairline-strong, rgba(255, 255, 255, 0.1))',
    disabledBg:     b.surface2Color  || 'var(--tz-hairline, rgba(255, 255, 255, 0.05))',
    radius:         '12px',
    radiusLg:       '16px',
    fontFamily:     "'Geist', -apple-system, BlinkMacSystemFont, sans-serif",
  };
}
